<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalMap"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width-map"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">CAUSES</div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <template v-for="(item, index) in dummy.level" :key="index">
              <div class="d-flex align-items-center" style="padding: 4px">
                <!-- <div
                  class="m-r-10"
                  style="font-size: 16px; font-weight: 700; flex: 0 0 10%"
                >
                  {{ item.value }}%
                </div> -->
                <div style="flex: 1">
                  <div style="font-size: 16px; color: rgba(0, 0, 0, 0.8)">
                    {{ item.metricName }}
                  </div>
                  <div
                    style="height: 20px"
                    class="progress custom_pb d-flex justify-content-between"
                  >
                    <div
                      class="progress-bar rounded-pill"
                      style="background-color: #00a3e9"
                      :style="{
                        width: item.value == '0' ? '1%' : item.value + '%',
                      }"
                      role="progressbar"
                      :aria-valuenow="item.value"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                    <div
                      class="m-r-5"
                      style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                    >
                      {{ item.value }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
import ModalNetwortMapChartVue from "./ModalNetwortMapChart.vue";

const apiDistribution = DistributionService.build();
export default {
  components: { ModalNetwortMapChartVue, IconSvg },
  props: ["distribution", "showModal", "dataMaps", "dataPoint"],
  data() {
    return {
      dummy: {
        level: [
          {
            metricName: "Fungsional I",
            value: "0",
          },
          {
            metricName: "Fungsional II",
            value: "6",
          },
          {
            metricName: "Fungsional III",
            value: "13",
          },
          {
            metricName: "Fungsional IV",
            value: "38",
          },
          {
            metricName: "Managemen Atas",
            value: "11",
          },
          {
            metricName: "Managemen Atas Khusus",
            value: "10",
          },
          {
            metricName: "Managemen Dasar",
            value: "9",
          },
          {
            metricName: "Managemen Menengah",
            value: "4",
          },
          {
            metricName: "Supervisory Atas",
            value: "10",
          },
        ],
        age: [
          {
            text: "55",
            percen: "4",
          },
          {
            text: "50y - 54y",
            percen: "6",
          },
          {
            text: "45y - 49y",
            percen: "13",
          },
          {
            text: "40y - 44y",
            percen: "18",
          },
          {
            text: "35y - 39y",
            percen: "11",
          },
          {
            text: "30y - 34y",
            percen: "30",
          },
          {
            text: "25y - 29y",
            percen: "9",
          },
          {
            text: "20y - 24y",
            percen: "4",
          },
          {
            text: "<20y",
            percen: "7",
          },
        ],
      },
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalMap);
  },

  methods: {
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    detailChart() {
      this.titleNetworks = "Kalimantan Barat";
      this.modalMap.show = true;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  watch: {
    async showModal() {
      if (this.showModal) {
        const data = this.dataMaps;
        const target = data[0].labels;
        const value = data[0].values;
        let dummy = [];

        for (let i = 0; i < target.length; i++) {
          let person = {
            metricName: target[i],
            value: value[i],
          };
          dummy.push(person);
        }
        this.dummy.level = dummy;
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style lang="scss">
.custom_header {
  padding: 1rem 1rem 0rem 1rem;
  border-bottom: unset;

  .custom_header_content {
    width: 100%;
    position: relative;

    .close_btn {
      position: absolute;
      right: 0;
      z-index: 999;
    }

    .tahun_text {
      font-size: 20px;
      font-weight: 400;
      line-height: 23px;
    }

    .judul_text {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}

.custom-modal-width {
  max-width: 564px;
  width: 100%;
}

.tabs {
  color: #838383;
  font-size: 14px;
  padding: 5px;
  cursor: pointer;
}

.tabs_active {
  color: #00a3e9;
  border-bottom: 3px solid #00a3e9;
}

.custom_pb {
  background: unset !important;
  height: 8px;
}
.clicked {
  border-color: #00a3e9 !important;
  background-color: #ecf9ff !important;
}
</style>
